import { useEffect, useRef, useState } from "react";
import axios from "axios";

const EthiccraftAbout = ({ collegeName }) => {
  const contentRef = useRef(null);
  const [collegeData, setCollegeData] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          contentRef.current.classList.add("animate-scroll-reveal");
        }
      },
      { threshold: 0.3 },
    );

    const cleanupRef = contentRef.current;
    if (cleanupRef) observer.observe(cleanupRef);
    return () => {
      if (cleanupRef) observer.unobserve(cleanupRef);
    };
  }, []);

  useEffect(() => {
    const fetchCollegeData = async () => {
      try {
        const res = await axios.get(
          "https://ethiccraft.org/backend/college_chapters/read_isShown.php",
        ); // Replace with actual API
        const college = res.data.find(
          (c) => c.visit_url.toLowerCase() === collegeName.toLowerCase(),
        );
        setCollegeData(college);
      } catch (error) {
        console.error("Error fetching college data:", error);
      }
    };

    fetchCollegeData();
  }, [collegeName]);

  return (
    <div className="ethiccraft-container">
      {collegeData && (
        <>
          <div
            className="ethiccraft-header"
            style={{
              backgroundImage: `url(https://ethiccraft.org/${collegeData.image})`,
            }}
          >
            <h1 className="ethiccraft-title typewriter">
              ETHICCRAFT {collegeData.university_name.toUpperCase()}
            </h1>
          </div>

          <div className="ethiccraft-content" ref={contentRef}>
            <h2>About the Society</h2>
            <p>
              At Ethiccraft {collegeData.university_name} Chapter, we believe in
              “Marching towards Value” every day. We serve as a vibrant forum
              where inherent goodness finds expression, and where students are
              empowered to shape a value-centered lifestyle that resonates well
              beyond college life. By cultivating a strong association of
              like-minded individuals, we create an uplifting support system in
              which knowledge, empathy, and collaborative spirit thrive.
            </p>
            <p>
              Our society offers personalized mentorship to address the unique
              goals and challenges of each member, ensuring that everyone’s
              journey is guided by thoughtful insight and purposeful action.
              Through regular community-building activities, we encourage
              teamwork over individualism, fostering an environment where shared
              ideals lead to collective growth.
            </p>
            <p>
              Ethiccraft {collegeData.university_name} Chapter also champions
              cultural preservation, recognizing the power of heritage and
              tradition in shaping moral character. We emphasize a keen sense of
              responsibility that inspires youth to become active contributors
              to society, while striving to maintain life equilibrium—balancing
              physical, intellectual, emotional, and spiritual well-being.
              Ultimately, we aim to nurture role models and inspirational
              leaders who will pioneer new frontiers and opportunities,
              reflecting the very best of what a values-driven community can
              achieve.
            </p>
            <p>
              Join us in our quest to transform goodness into action, one step
              at a time—together, we are Marching towards Value.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default EthiccraftAbout;
